import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';

import { ComponentDefinition, IValueViewModel, TagDateValue, SeriesDefinition, SelectorType, NameBuilderConfiguration, Dictionary } from '../../../models';
import { ChartConfigurationOption } from '../../../wtFramework';
import { IWidgetConfiguration, SeriesConfiguration, IWidgetFactory } from '../../../widgets';
import { IAuthorizationService, IStoreService } from '../../../services';
import { Helper, momentFormat, Roles } from '../../../common';
import { Store, StoreElement } from '../../../stateManagement';

class ValidatedGeneralController implements angular.IComponentController {
    currentBeginDate: string;
    currentEndDate: string;
    currentInterval: any;
    data: TagDateValue[];
    groupGuid: string;
    hasManualInputRole: boolean;
    identifier: IValueViewModel;
    identifierGuid: string;
    initialRange: { beginDate: any, endDate: any; };
    isLoading: boolean;
    loadingMessage: string;
    options: ChartConfigurationOption;
    series: SeriesDefinition<TagDateValue>[];
    trend: any;
    viewModels: Dictionary<IValueViewModel>;
    private _garbages: (() => void)[];

    static $inject = [
        '$scope',
        '$state',
        'storeService',
        'widgetFactory',
        'authorizationService',
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$state: ng.ui.IStateService,
        private _storeService: IStoreService,
        private _widgetFactory: IWidgetFactory,
        authorizationService: IAuthorizationService
    ) {
        this.hasManualInputRole = authorizationService.isInRoles(Roles.manualInputRoles);
    }

    $onInit() {
        this._garbages = [];
        const { identifierGuid, beginDate, endDate } = this._$state.params;

        if (identifierGuid) {
            this.identifierGuid = identifierGuid;
        }

        if (beginDate && endDate) {
            this.initialRange = {
                beginDate: moment(beginDate).format(momentFormat),
                endDate: moment(endDate).format(momentFormat)
            };
        }

        this.createTrend();

        this._garbages.push(this._storeService.register(
            store => this.refreshStore(store),
            [StoreElement.ValueViewModels]
        ));


        this._garbages.push(this._$scope.$watchGroup(
            [() => this.currentBeginDate, () => this.currentEndDate],
            () => {
                this.currentInterval = {
                    startDate: this.currentBeginDate,
                    endDate: this.currentEndDate
                };
            }
        ));
    }

    $onDestroy(): void {
        if (this._garbages?.length) {
            this._garbages.forEach(g => g());
        }
    }

    private refreshStore(store: Store): void {
        this.viewModels = store.valueViewModels.dictionary;
        const vm = this.viewModels[this.identifierGuid];
        if (vm) {
            this._$state.current.data.breadcrumbs.level4 = vm.name;
            this.identifier = vm;
            this.groupGuid = vm.groupList[0].guid;
            this.createSeries();
        }
    }

    private initOptions(): ChartConfigurationOption {
        const options = new ChartConfigurationOption();
        options.isTitleVisible = false;
        options.isLegendVisible = true;
        options.isHorizontalGridlinesVisible = true;
        options.panes = [
            {
                height: 1,
                isXaxisVisible: true,
                isYaxisVisible: true,
                isHorizontalGridLinesVisible: true
            }
        ];

        return options;
    }

    private createSeries() {
        const series: SeriesConfiguration[] = [];
        const baseSerie = new SeriesConfiguration(this.identifier.guid, Helper.getColor(0), 'circle');

        baseSerie.valueType = 'validatedvalue';
        baseSerie.type = SelectorType.identifier;
        baseSerie.value = 'validatedvalue';
        baseSerie.isLineVisible = true;
        baseSerie.isSymbolVisible = false;
        baseSerie.renderingMode = 'wide-step';
        series.push(baseSerie);

        const valueType = this.identifier.valueType ? this.identifier.valueType : 'average';
        this.identifier.selectableIdentifiers.forEach((i, index) => {
            const serie = new SeriesConfiguration(i.guid, Helper.getColor(index + 1), 'circle');
            serie.valueType = valueType;
            serie.type = SelectorType.identifier;
            serie.value = valueType;
            serie.isLineVisible = false;
            serie.isSymbolVisible = true;
            series.push(serie);
        });
        this.trend.configuration.series = series;
    }

    private createTrend() {
        const config: IWidgetConfiguration = {};
        this.options = this.initOptions();
        const trend: any = <any>this._widgetFactory.createWidget('tagsTrend', config);
        trend.configuration.options = this.options;
        trend.configuration.series = []; // TODO insert series
        trend.configuration.isEndDateIncluded = true;
        const nameConfig = new NameBuilderConfiguration();
        nameConfig.hasGroupName = true;
        trend.configuration.nameConfiguration = nameConfig;
        this.trend = trend;
    }
}

export const wtValidatedGeneral: ComponentDefinition = {
    componentId: 'wtValidatedGeneral',
    controller: ValidatedGeneralController,
    template: require('./validatedGeneral.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};